// extracted by mini-css-extract-plugin
export var headerMobileTop = "HeaderNavMobile_headerMobileTop__aAR3U";
export var hrWalletActions = "HeaderNavMobile_hrWalletActions__X32Ct";
export var dropdownWalletActions = "HeaderNavMobile_dropdownWalletActions__q+nXJ";
export var rotate = "HeaderNavMobile_rotate__QVbv2";
export var dotty = "HeaderNavMobile_dotty__-taF0";